import React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import {
  StModalContainerWithModal,
  StmodalContainer,
  StHeadingContainer,
  StFooterbuttons,
} from './CustomModal.styles';
import ButtonPrimary from '../Button/PrimaryButton';
import { RichText } from '@sitecore-jss/sitecore-jss-nextjs';

interface IGeneralModalProps {
  children: React.ReactNode;
  open: boolean;
  heading?: string;
  showActionButton?: boolean;
  actionButtonText?: string;
  onActionButtonClick?: () => void;
  onClose?: () => void;
  style?: React.CSSProperties;
}

const GeneralModal: React.FC<IGeneralModalProps> = (props) => {
  const heading = props.heading || '';
  const actionButtonText = props.actionButtonText || 'Close';
  const style = props.style || {};
  const onClose = props.onClose;
  return (
    <Modal
      open={props.open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <StModalContainerWithModal sx={style}>
        <StmodalContainer
          sx={{
            width: '500px',
            height: '246px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <Box>
            <StHeadingContainer>
              <RichText field={{ value: heading }} id="modal-modal-title"></RichText>
            </StHeadingContainer>
            {props.children}
          </Box>
          {props.showActionButton && (
            <StFooterbuttons>
              <ButtonPrimary onClick={props.onActionButtonClick}>{actionButtonText}</ButtonPrimary>
            </StFooterbuttons>
          )}
        </StmodalContainer>
      </StModalContainerWithModal>
    </Modal>
  );
};

export default GeneralModal;
